import { createRouteRef } from '@backstage/core-plugin-api';
import { SECCOMP_PLUGIN_ID } from '@mercedes-benz/seccomp-dashboard-common';

export const rootRouteRef = createRouteRef({
  id: SECCOMP_PLUGIN_ID,
});
